import { ObjectUtil } from 'app/utils/object.util';

export class Overview {
  /* eslint-disable */
  WTUR1_kW_theoretical: number;
  WTUR1_kW_rated: number;
  WTUR1_kW_mag_f: number;
  WTUR1_kW_loss: number;
  WTUR1_MW_theoretical: number;
  WTUR1_MW_rated: number;
  WTUR1_MW_mag_f: number;
  WTUR1_MW_loss: number;
  WNAC1_WdSpd_mag_f: number;
  WNAC1_WdDir_mag_f: number;
  WNAC1_ExTmp_mag_f: number;
  WTUR1_per_efficiency: number;
  WTUR1_per_loadFactor: number;
  WNAC1_Dir_mag_f?: number;
  WTUR1_status?: number;
  name?: string;
  fe_name?: string;
  worst_five?: boolean;
  serialNav?: number;
  serialDisplay?: string;
  code?: string;
  LDAT1_TmUTC_setTm?: Date;
  no_data?: boolean;
  weather_icon: string;
  LDAT1_TmUTC_setTm_rounded?: Date;
  dataAquisitionMax?: Date;
  hasAlarm?: boolean;
  /* eslint-enable */

  static mapFromPortfolio(park: any) {
    return new Overview({
      fe_name: park.fe_name,
      name: park.name,
      WTUR1_MW_loss: park.data.WTUR1_MW_loss.sum,
      WTUR1_MW_mag_f: park.data.WTUR1_MW_mag_f.sum,
      WTUR1_MW_rated: park.dataDebbug.WTUR1_MW_rated.sum,
      WTUR1_MW_theoretical: park.data.WTUR1_MW_theoretical.sum,
      WTUR1_per_loadFactor: park.data.WTUR1_per_loadFactor.avg,
      WTUR1_per_efficiency: park.data.WTUR1_per_efficiency.avg,
      WNAC1_WdDir_mag_f: park.data.WNAC1_WdDir_mag_f.avg || park.data.WNAC1_Dir_mag_f.avg,
      WNAC1_ExTmp_mag_f: park.data.WNAC1_ExTmp_mag_f.avg,
      WNAC1_WdSpd_mag_f: park.data.WNAC1_WdSpd_mag_f.avg,
      WTUR1_status: park.data.WTUR1_status.min,
      weather_icon: ObjectUtil.getProperty(park, 'currentWeather.icon', null),
      dataAquisitionMax: park.metaData.dataAquisitionMax.unixTimestamp,
      hasAlarm: this.hasAlarm(park.turbines)
    });
  }

  static mapFromPark(turbine: any) {
    return new Overview({
      no_data: turbine.data ? false : true,
      code: turbine.code,
      serialNav: turbine.serialNav,
      serialDisplay: turbine.serialDisplay,
      WTUR1_kW_loss: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_loss', null),
      WTUR1_kW_mag_f: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_mag_f', null),
      WTUR1_kW_rated: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_rated', null),
      WTUR1_kW_theoretical: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_theoretical', null),
      WTUR1_per_loadFactor: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_loadFactor', null),
      dataAquisitionMax: ObjectUtil.getProperty(turbine, 'metaData.dataAquisitionMax.unixTimestamp', null),
      WNAC1_WdSpd_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdSpd_mag_f', null),
      WNAC1_ExTmp_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_ExTmp_mag_f', null),
      WNAC1_WdDir_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdDir_mag_f', null) || ObjectUtil.getProperty(turbine, 'data.WNAC1_Dir_mag_f', null),
      WTUR1_per_efficiency: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_efficiency', null),
      WTUR1_status: ObjectUtil.getProperty(turbine, 'data.WTUR1_status', null),
      WNAC1_Dir_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_Dir_mag_f', null)
    });
  }

  static hasAlarm(turbines: []): boolean {
    const redFound = turbines.filter((turbine: any) =>
      ObjectUtil.getProperty(turbine, 'data.WTUR1_status', null) === 2
    ).length > 0;
    return redFound;
  }

  constructor(init: Partial<Overview>) {
    Object.assign(this, init);
  }

}
